import styled from '@emotion/styled'
import { IconButton } from '@mui/material'
import React from 'react'

import { ExpandArrowIcon } from '@f-fertighaus/applications/Next/components/fertighaus/Icon/ExpandArrowIcon'

interface Props {
  onContentClick: () => void
  onExpandIconClick: (event: React.MouseEvent<HTMLButtonElement>) => void
  rounded?: boolean
  children: React.ReactNode
}

export const ImageGalleryImageBox = (props: Props) => {
  return (
    <Wrapper onClick={props.onContentClick} rounded={props.rounded}>
      {props.children}
      <ExpandImageButton
        aria-label='Bild vergrößern'
        data-sel='btn-zoom'
        onClick={props.onExpandIconClick}
        sx={{ width: 32, height: 32 }}>
        <ExpandArrowIcon />
      </ExpandImageButton>
    </Wrapper>
  )
}

const ExpandImageButton = styled(IconButton)`
  position: absolute;
  bottom: ${({ theme }) => theme.spacing(2)};
  right: ${({ theme }) => theme.spacing(2)};
  border-radius: var(--border-radius-cta);
  background: ${({ theme }) => theme.palette.background.paper};
  box-shadow: 0 5px 10px -1px rgba(59, 71, 104, 0.05), 0 2px 4px -3px #3b4768,
    0 2px 40px 0 rgba(59, 71, 104, 0.05);

  &:hover {
    background: ${({ theme }) => theme.palette.background.paper};
  }
  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.palette.primary.main};
  }
`

const Wrapper = styled.div<{ rounded?: boolean }>`
  position: relative;
  margin-bottom: ${({ theme }) => theme.spacing(1)};
  cursor: pointer;
  width: 100%;
  padding-top: 75%;
  background: ${({ theme }) => theme.palette.background.paper};

  box-shadow: 0 5px 10px -1px rgba(59, 71, 104, 0.05), 0 2px 4px -3px #3b4768,
    0 2px 40px 0 rgba(59, 71, 104, 0.05);

  ${({ rounded }) =>
    rounded &&
    `
    border-radius: var(--border-radius-card-large);
    
    & img {
      border-radius: var(--border-radius-card-large);
    }
  `}

  ${({ theme }) => theme.breakpoints.down('md')} {
    padding-top: 0;
  }
`
